import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

export default function Logo({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/logo.png',
    alt: 'Logo V-LAB',
  }
  if (isMobile) {
    return (
      <StaticImage
        height={205}
        width={352}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return <StaticImage height={326} {...imgProps} placeholder="blurred" />
}
